import { Button, Typography } from 'omakase';
import { CircularProgress } from '@material-ui/core';
import { FunctionComponent, useState } from 'react';
import { IconLocationFilled } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconMyLocation } from 'ui/icons';
import {
  PatronLocationEntity,
  geocodeResultToPatronLocation,
} from 'components/patron-location/PatronLocation';
import { currentLocationButton } from 'components/patron-location/patronLocationCssDefs';
import { getGeocodedLocation, responsiblyGetCurrentPosition } from 'utils/locationUtils';
import { useActions } from '@tock/shared/utils/connect';

interface PatronLocationFinderCurrentPositionProps {
  onResult(result: PatronLocationEntity): void;
}

export const PatronLocationFinderCurrentPosition: FunctionComponent<
  PatronLocationFinderCurrentPositionProps
> = ({ onResult }) => {
  const [locating, setLocating] = useState(false);
  const { actions } = useActions();

  // Must always be called as a result of a user action
  const getPosition = async () => {
    try {
      setLocating(true);
      const coordinates = await responsiblyGetCurrentPosition(true);
      if (coordinates && coordinates.latitude && coordinates.longitude) {
        const result = await getGeocodedLocation(coordinates.latitude, coordinates.longitude);
        const item = await geocodeResultToPatronLocation(
          result[0],
          actions.metroArea.findClosestMetroArea
        );
        onResult(item);
      }
      setLocating(false);
    } catch (_error) {
      setLocating(false);
    }
  };

  const disabled = locating;

  const primaryText = (
    <Typography color="inherit" variant="body01Strong" component="span" tabIndex={-1}>
      Use current location
    </Typography>
  );

  return (
    <Button
      iconStart={
        disabled ? (
          <CircularProgress color="inherit" size={20} />
        ) : (
          <IconMigrationUtil legacyIcon={<IconMyLocation />} newIcon={<IconLocationFilled />} />
        )
      }
      variant="basic"
      size="large"
      fullWidth
      disabled={disabled}
      onClick={getPosition}
      css={currentLocationButton}
    >
      {primaryText}
    </Button>
  );
};
